/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Namespaces } from '../../i18n';
import { INotification } from '../../store/notifications/types';
import { AppServerEvents } from '../../types/common/AppEvents';
import { NotificationItemFrameOptions } from '../../types/notification/NotificationItemFrameOptions';
import { useNotificationRelativeDate } from '../../utils/useNotificationRelativeDate';
import { NotificationItemFrame } from '../NotificationItemFrame/NotificationItemFrame';

type ProjectMembershipNotificationProps = NotificationItemFrameOptions & {
  notification: INotification<AppServerEvents.RemovedFromProject | AppServerEvents.AddedToProject>;
};

export function ProjectMembershipNotification(props: ProjectMembershipNotificationProps) {
  const { notification, setNotificationAsRead, onRemoveBtnClick, asSnackbar, onRootClick } = props;
  const { t } = useTranslation([Namespaces.Navigation]);
  const { isRead, event, createdAt, type } = notification;
  const { project, user } = event;
  const [datetime] = useNotificationRelativeDate(createdAt);
  return (
    <NotificationItemFrame
      datetime={datetime}
      setNotificationAsRead={setNotificationAsRead}
      isRead={asSnackbar ? true : isRead}
      id={notification.id}
      onRemoveBtnClick={onRemoveBtnClick}
      asSnackbar={asSnackbar}
      onRootClick={onRootClick}
      primaryText={
        type === AppServerEvents.AddedToProject
          ? t(`notifications.templates.user_added_you_to_project`, {
              user: `${user.firstName} ${user.lastName}`,
            })
          : t(`notifications.templates.user_removed_you_from_project`, {
              user: `${user.firstName} ${user.lastName}`,
            })
      }
      secondaryText={project.name}
    />
  );
}
